import React from 'react';

export const IconFitting =() => {
	return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17"><path d="M14,6a2,2,0,1,0-4,0,4.761,4.761,0,0,0,2,4H12l7.971,4.428A2,2,0,0,1,21,16.177V17a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2v-.823a2,2,0,0,1,1.029-1.749L12,10" transform="translate(-2 -3)" fill="none" stroke="#111827" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/></svg>;
}